import { themeUi } from '../../themeUi/themeUi';

export const usageReport = {
  sectionTitle: {
    color: themeUi.semantic.color.text.neutral800,
    spanColor: themeUi.semantic.color.text.neutral700,
    beforeColor: themeUi.semantic.color.text.neutral800
  },
  label: {
    color: themeUi.semantic.color.text.neutral800
  }
};
